import styled from 'styled-components';
import classNames from 'classnames';
import { Box, BoxProps } from '../box';
import { deviceSizes } from '../../style';

const Column = styled(Box)`
  width: 100%;
  flex-wrap: wrap;
  max-width: 100%;
  flex-basis: 100%;

  &.col-auto {
    width: auto;
    max-width: none;
  }

  &.col-1 {
    max-width: 8.333333%;
    flex-basis: 8.333333%;
  }

  &.col-2 {
    max-width: 16.666667%;
    flex-basis: 16.666667%;
  }

  &.col-3 {
    max-width: 25%;
    flex-basis: 25%;
  }

  &.col-4 {
    max-width: 33.333333%;
    flex-basis: 33.333333%;
  }

  &.col-5 {
    max-width: 41.666667%;
    flex-basis: 41.666667%;
  }

  &.col-6 {
    max-width: 50%;
    flex-basis: 50%;
  }

  &.col-7 {
    max-width: 58.333333%;
    flex-basis: 58.333333%;
  }

  &.col-8 {
    max-width: 66.666667%;
    flex-basis: 66.666667%;
  }

  &.col-9 {
    max-width: 75%;
    flex-basis: 75%;
  }

  &.col-10 {
    max-width: 83.333333%;
    flex-basis: 83.333333%;
  }

  &.col-11 {
    max-width: 91.666667%;
    flex-basis: 91.666667%;
  }

  &.col-12 {
    max-width: 100%;
    flex-basis: 100%;
  }

  @media (min-width: 0) {
    &.col-xs {
      max-width: 100%;
      flex-basis: 100%;
    }

    &.col-xs-auto {
      width: auto;
      max-width: none;
    }

    &.col-xs-1 {
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    &.col-xs-2 {
      max-width: 16.666667%;
      flex-basis: 16.666667%;
      flex-basis: 16.666667%;
    }

    &.col-xs-3 {
      max-width: 25%;
      flex-basis: 25%;
    }

    &.col-xs-4 {
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    &.col-xs-5 {
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    &.col-xs-6 {
      max-width: 50%;
      flex-basis: 50%;
    }

    &.col-xs-7 {
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    &.col-xs-8 {
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    &.col-xs-9 {
      max-width: 75%;
      flex-basis: 75%;
    }

    &.col-xs-10 {
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    &.col-xs-11 {
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    &.col-xs-12 {
      max-width: 100%;
      flex-basis: 100%;
    }
  }

  @media (min-width: ${deviceSizes.sm}) {
    &.col-sm {
      max-width: 100%;
      flex-basis: 100%;
    }

    &.col-sm-auto {
      width: auto;
      max-width: none;
    }

    &.col-sm-1 {
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    &.col-sm-2 {
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    &.col-sm-3 {
      max-width: 25%;
      flex-basis: 25%;
    }

    &.col-sm-4 {
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    &.col-sm-5 {
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    &.col-sm-6 {
      max-width: 50%;
      flex-basis: 50%;
    }

    &.col-sm-7 {
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    &.col-sm-8 {
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    &.col-sm-9 {
      max-width: 75%;
      flex-basis: 75%;
    }

    &.col-sm-10 {
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    &.col-sm-11 {
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    &.col-sm-12 {
      max-width: 100%;
      flex-basis: 100%;
    }
  }

  @media (min-width: ${deviceSizes.md}) {
    &.col-md {
      flex-grow: 1;
      max-width: 100%;
      flex-basis: 100%;
    }

    &.col-md-auto {
      width: auto;
      max-width: none;
    }

    &.col-md-1 {
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    &.col-md-2 {
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    &.col-md-3 {
      max-width: 25%;
      flex-basis: 25%;
    }

    &.col-md-4 {
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    &.col-md-5 {
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    &.col-md-6 {
      max-width: 50%;
      flex-basis: 50%;
    }

    &.col-md-7 {
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    &.col-md-8 {
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    &.col-md-9 {
      max-width: 75%;
      flex-basis: 75%;
    }

    &.col-md-10 {
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    &.col-md-11 {
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    &.col-md-12 {
      flex: 0 0 100%;
      max-width: 100%;
      flex-basis: 100%;
    }
  }

  @media (min-width: ${deviceSizes.lg}) {
    &.col-lg {
      flex-grow: 1;
      max-width: 100%;
      flex-basis: 100%;
    }

    &.col-lg-auto {
      width: auto;
      max-width: none;
    }

    &.col-lg-1 {
      max-width: 8.333333%;
      flex-basis: 8.333333%;
    }

    &.col-lg-2 {
      max-width: 16.666667%;
      flex-basis: 16.666667%;
    }

    &.col-lg-3 {
      max-width: 25%;
      flex-basis: 25%;
    }

    &.col-lg-4 {
      max-width: 33.333333%;
      flex-basis: 33.333333%;
    }

    &.col-lg-5 {
      max-width: 41.666667%;
      flex-basis: 41.666667%;
    }

    &.col-lg-6 {
      max-width: 50%;
      flex-basis: 50%;
    }

    &.col-lg-7 {
      max-width: 58.333333%;
      flex-basis: 58.333333%;
    }

    &.col-lg-8 {
      max-width: 66.666667%;
      flex-basis: 66.666667%;
    }

    &.col-lg-9 {
      max-width: 75%;
      flex-basis: 75%;
    }

    &.col-lg-10 {
      max-width: 83.333333%;
      flex-basis: 83.333333%;
    }

    &.col-lg-11 {
      max-width: 91.666667%;
      flex-basis: 91.666667%;
    }

    &.col-lg-12 {
      flex: 0 0 100%;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
`;

export type columnSizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface ColProps extends BoxProps {
  xs?: columnSizes;
  sm?: columnSizes;
  md?: columnSizes;
  lg?: columnSizes;
  size?: columnSizes;
}

export const Col = ({ display = 'block', xs = 12, sm, md, lg, className, size, ...rest }: ColProps) => (
  <Column
    className={classNames(
      'column',
      {
        [`col-${size}`]: size,
        [`col-xs-${xs}`]: xs,
        [`col-sm-${sm}`]: sm,
        [`col-md-${md}`]: md,
        [`col-lg-${lg}`]: lg,
      },
      className,
    )}
    display={display}
    {...rest}
  />
);

export default Col;
